module.exports = __webpack_public_path__ + "static/img/1_2_2.59de8e4f.jpg";